import React, { useState, useEffect } from "react";
import axios from "axios";
import api from '../utils/api';
import {
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Button,
} from "@mui/material";

function AmazonDashboard() {
  const [orders, setOrders] = useState([]);
  const [financials, setFinancials] = useState(null);
  const [loadingOrders, setLoadingOrders] = useState(false);
  const [loadingFinancials, setLoadingFinancials] = useState(false);

  useEffect(() => {
    fetchOrders();
    fetchFinancials();
  }, []);

  const fetchOrders = () => {
    setLoadingOrders(true);
    axios
      .get("/amazon/orders")
      .then((response) => setOrders(response.data.Orders || []))
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          // Redirige l'utilisateur pour s'authentifier
          window.location.href = "/amazon/callback";
        } else {
          console.error(err);
        }
      })
      .finally(() => setLoadingOrders(false));
  };

  const fetchFinancials = () => {
    setLoadingFinancials(true);
    axios
      .get("/amazon/financials")
      .then((response) => setFinancials(response.data))
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          window.location.href = "/amazon/callback";
        } else {
          console.error(err);
        }
      })
      .finally(() => setLoadingFinancials(false));
  };

  return (
    <div style={{ padding: "20px" }}>
      <Typography variant="h4" gutterBottom>
        Gestion Seller Central Amazon
      </Typography>
      <Button
        variant="contained"
        onClick={fetchOrders}
        style={{ marginRight: "10px" }}
      >
        Rafraîchir Commandes
      </Button>
      <Button variant="contained" onClick={fetchFinancials}>
        Rafraîchir Finances
      </Button>

      <Typography variant="h6" style={{ marginTop: "20px" }}>
        Commandes
      </Typography>
      {loadingOrders ? (
        <CircularProgress />
      ) : orders.length > 0 ? (
        <TableContainer component={Paper} style={{ marginTop: "10px" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>ID Commande</TableCell>
                <TableCell>Date d'Achat</TableCell>
                <TableCell>Statut</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {orders.map((order) => (
                <TableRow key={order.AmazonOrderId}>
                  <TableCell>{order.AmazonOrderId}</TableCell>
                  <TableCell>{order.PurchaseDate}</TableCell>
                  <TableCell>{order.OrderStatus}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Typography>Aucune commande trouvée.</Typography>
      )}

      <Typography variant="h6" style={{ marginTop: "20px" }}>
        Informations Financières
      </Typography>
      {loadingFinancials ? (
        <CircularProgress />
      ) : financials ? (
        <Paper style={{ padding: "10px", marginTop: "10px" }}>
          <Typography variant="body1">
            {JSON.stringify(financials, null, 2)}
          </Typography>
        </Paper>
      ) : (
        <Typography>Aucune donnée financière disponible.</Typography>
      )}
    </div>
  );
}

export default AmazonDashboard;
